<template>
    <table class="table no-border">
        <tr v-if="selectable" class="bb-1 selectable-line">
            <td v-for="(column, indexColumn) in lines[0]" :key="indexColumn" class="br-1" :class="{'primary-05-bkg' : isSelected(indexColumn)}">
                <a @click="selectColumn(indexColumn)" class="link semibold">{{ $l10n.__("Sélectionner") }}</a>
            </td>
        </tr>
        <tr v-for="(line, index) in lines" :key="index" class="bb-1">
            <td 
                v-for="(column, indexColumn) in line" 
                :key="indexColumn" 
                class="br-1 mw-96" 
                :class="[
                    {'primary-05-bkg' : isSelected(indexColumn)},
                    {'error' : hasError(indexColumn, line)}
                ]"
                v-if="indexColumn != 'errors'">
                {{ hasError(indexColumn, line) ? line.errors[indexColumn]: column }}
            </td>
        </tr>
    </table>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                required: false,
                default: () => []
            },
            lines: {
                type: Array,
                required: true
            },
            max: {
                type: [Number, Boolean],
                required: false,
                default: false
            },
            selectable: {
                type: Boolean,
                required: false,
                default: true
            },
            format: {
                type: String,
                required: false,
                default: 'array',
                validator (val) {
                    return ['array', 'object'].includes(val)
                }
            }
        },
        data(){
            return {
            }
        },
        methods: {
            selectColumn(index){
                if(this.isSelected(index)){
                    this.value.splice(this.value.findIndex(valueIndex => valueIndex == index), 1)
                } else{
                    if(this.max && this.value.length < this.max){
                        this.value.push(index)
                    } else{
                        if(this.max == 1){
                            this.$emit('input', [index])
                        } else{
                            Push.error(this.$l10n.__('Vous ne pouvez pas sélectionner plus de %(nb)s colonnes', {nb: this.max}), false)
                        }
                    }
                }
            },
            isSelected(index){
                return this.value.includes(index)
            },
            hasError(index, line){
                return line.errors && line.errors[index]
            }
        }
    }
</script>

<style scoped>
.error{
    background-color: #F67D8C !important;
    color: white;
}
.selectable-line{
    height: 48px;
}
</style>
